import { Loader } from "lucide-react";
import { cn } from "~/utils/cn";

interface SpinnerProps {
  size?: number;
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ size = 24, className }) => {
  return (
    <div className={cn("flex justify-center items-center", className)}>
      <Loader className="animate-spin" size={size} />
    </div>
  );
};

export default Spinner;
